import { render, staticRenderFns } from "./CustomerOrderHistoryTab.vue?vue&type=template&id=5baa7e6e&scoped=true"
import script from "./CustomerOrderHistoryTab.vue?vue&type=script&lang=js"
export * from "./CustomerOrderHistoryTab.vue?vue&type=script&lang=js"
import style0 from "./CustomerOrderHistoryTab.vue?vue&type=style&index=0&id=5baa7e6e&prod&scoped=true&lang=css"
import style1 from "./CustomerOrderHistoryTab.vue?vue&type=style&index=1&id=5baa7e6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baa7e6e",
  null
  
)

export default component.exports